import { isApolloError } from 'apollo-client';

// Note: These functions rely on an http_error_code being present in the
// extensions object of the error. This is currently unique to r101-coaching
// but could eventually be provided by other services

/* isUnauthenticated determines if the user is unauthenticated based on a 401
 * response in a given error. Not all upstream GraphQL service provide this
 * field as an extension - currently only r101-coaching.
 */
function isUnauthenticated(error: any): boolean {
  if (isApolloError(error)) {
    return error.graphQLErrors.some(err => err.extensions?.http_error_code === 401);
  }

  return false;
}

/**
 * reloadIfUnauthenticated is used to reload in the page in the event that a
 * user becomes unauthenticated. This is useful for getting the React app back
 * into a known good state by triggering the standard auth logic that happens
 * on app start.
 *
 * This function should only be called where it is VERY RARE that a user would
 * be unauthenticated - such as because a token has expired - and not as part
 * of a standard, expected application flow. Reloading the app is the slowest
 * of many options.'
 *
 * Reloading the page generally stops JS execution so don't expect any code
 * following this function to run.
 */
export function reloadIfUnauthenticated(error: any): void {
  if (isUnauthenticated(error)) {
    location.reload();
  }
}
